import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import StarIcon from "@mui/icons-material/Star";
import { cleanList, cleanText } from "./utils/doctorDisplay";
export function DoctorSquareCard({ display, isSelected, onSelect, mobile = false, }) {
    const name = cleanText(display.name) ?? "";
    const specialization = cleanList(display.specializations)[0] ?? "General Physician";
    const initials = name
        .split(" ")
        .filter(Boolean)
        .map((p) => p[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    const avatarRing = mobile ? 78 : 92;
    const avatarSize = mobile ? 66 : 78;
    return (_jsxs(Box, { onClick: onSelect, role: "button", "aria-pressed": isSelected, sx: {
            position: "relative",
            width: mobile ? 156 : 188,
            flexShrink: 0,
            pt: "18px",
            pb: "16px",
            px: "12px",
            borderRadius: 3,
            border: isSelected ? 2 : 1,
            borderColor: isSelected ? "primary.main" : "divider",
            bgcolor: isSelected ? "primary.light" : "background.default",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            boxShadow: isSelected
                ? "0 0 0 3px rgba(21,59,98,0.10)"
                : "0 1px 3px rgba(15,23,42,0.05)",
            transition: "all 0.2s ease",
            "&:hover": {
                borderColor: "primary.main",
                boxShadow: "0 6px 20px rgba(21,59,98,0.10)",
            },
        }, children: [display.googleRating != null && (_jsxs(Box, { sx: {
                    position: "absolute",
                    top: 14,
                    left: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.4,
                    pl: 1,
                    pr: 1.75,
                    py: 0.55,
                    bgcolor: "#AED5A3",
                    color: "#173B18",
                    clipPath: "polygon(0 0, 100% 0, 82% 50%, 100% 100%, 0 100%)",
                    boxShadow: "0 1px 3px rgba(15,23,42,0.12)",
                }, children: [_jsx(StarIcon, { sx: { fontSize: 14, color: "#2E7D32" } }), _jsx(Typography, { sx: { fontSize: 12, fontWeight: 700, lineHeight: 1 }, children: display.googleRating.toFixed(1) })] })), _jsx(Box, { sx: {
                    width: avatarRing,
                    height: avatarRing,
                    borderRadius: "50%",
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1.5,
                    flexShrink: 0,
                    overflow: "hidden",
                    boxShadow: "0 4px 14px rgba(15,23,42,0.12)",
                }, children: _jsx(Avatar, { src: display.profileImageUrl ?? undefined, alt: name, sx: {
                        width: avatarSize,
                        height: avatarSize,
                        bgcolor: "#F0F4F8",
                        color: "#153B62",
                        fontWeight: 700,
                        fontSize: mobile ? 20 : 24,
                    }, children: initials }) }), name && (_jsx(Typography, { sx: {
                    fontSize: mobile ? 13.5 : 15,
                    fontWeight: 700,
                    mb: 1,
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    width: "100%",
                    color: "text.primary",
                }, children: name })), _jsx(Box, { sx: {
                    maxWidth: "100%",
                    bgcolor: "#EDE3C9",
                    color: "#9A7B2E",
                    fontSize: mobile ? 11 : 12,
                    fontWeight: 600,
                    borderRadius: 1.25,
                    px: 1.5,
                    py: 0.6,
                    lineHeight: 1.3,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }, children: specialization })] }));
}
